import React, {useState, useEffect} from 'react'
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess, isMindPro } from '../utils/permissions';
import T from '../components/Translation';
import { dT } from '../components/Translation';
import { useSignup } from '../whitaijiFrontendLibrary/auth/hooks/useSignup';
import { errorAlert, successAlert } from '../utils/utils';
import { generateMongoDBId, fullNameOrEmail, addNameSwal } from '../whitaijiFrontendLibrary/lib/utils';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { _CREATE, _FETCH, _UPDATE } from '../utils/patches';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import RichTextEditor from '../whitaijiFrontendLibrary/textEditors/RichTextEditor';
import draftToHtml from 'draftjs-to-html';
import { FiEdit } from "react-icons/fi";
import VisDiv from '../components/VisDiv';
import { blueColour, goldColour, lighterBlueColour, Tag } from './Home';
import useMediaQuery from '../hooks/useMediaQuery';
import { CiCircleCheck } from "react-icons/ci";
import { HiCheckCircle, HiPlusCircle } from "react-icons/hi2";
import TrueFalseToggle from '../whitaijiFrontendLibrary/components/TrueFalseToggle';
import PromiseQueue from 'p-queue'
import { landingPages } from './landingPages/landingPagesIndex';
import Swal from 'sweetalert2';
import { ReportLine } from './JournalEntry';
import format from 'date-fns/format'
import { TbReportAnalytics } from "react-icons/tb";
import Divider from '../whitaijiFrontendLibrary/components/Divider';

const CreateCampaign = () => {

      const {user} = useAuthContext(AuthContext)
      const {hideTestButtons, apiUrl, language} = useStateContext()
      const {signup, error, isLoading, result} = useSignup(AuthContext)
      const [email, setEmail] = useState("")
      const [firstName, setFirstName] = useState()
      const [emailError, setEmailError] = useState(null)
      const [campaign, setCampaign] = useState()
      const [addNewCampaign, setAddnewCampaign] = useState(false)
  
const { data: userProfileData, error: userDataError, isLoading: userProfileDataLoading } = useQuery({
      queryKey: ['userProfileData'],
      enabled: !!user, // Only fetch if user is logged in
      queryFn: async () => {
          const userData = await _FETCH({
            route: `${apiUrl}/user/get-user-profile/${user._id}`,
            user,
          });

          return userData;
        }
  });
        const { data: prospectsData, isLoading: ProspectsDataLoading} = useQuery({
          queryKey: ['prospectsData'],
          enabled: !!user,
          queryFn: async () => await _FETCH({route: `${apiUrl}/prospects`, user})
        });

  const { data: campaignsData, error: campaignsDataError, isLoading: campaignsDataLoading } = useQuery({
        queryKey: ['campaignsData'],
        enabled: !!user, // Only fetch if user is logged in
        queryFn: async () => {
            const userData = await _FETCH({
              route: `${apiUrl}/campaigns`,
              user,
            });

            return userData;
          }
    });
      const { data: surveys, isLoading: surveysLoading } = useQuery({
        queryKey: ['surveysData'],
        queryFn: async () => {
          try {
            const response = await fetch(`${apiUrl}/surveys`, {
              headers: {
                'Authorization': `Bearer ${user.token}`
              }
            });
            const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("surveys loaded", data)
            return data;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching surveys:', error);
            return [];
          }
        },
        enabled: !!user // Only fetch if user is logged in
      });

      const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("testFunction",
          { 
            campaignsData,

          }
        )
        }
  if(campaignsDataLoading || ProspectsDataLoading || userProfileDataLoading || surveysLoading) {
    return <Loading />
  }

  return (
    <div style={{}}>
        <BlueButton hideTestButtons={hideTestButtons} fn={testFunction}/>
         <BlueButton text={addNewCampaign ? "Close" : "Add New Campaign"} fn={()=>setAddnewCampaign(!addNewCampaign)}/>
        <CampaignForm surveysData={surveys} prospectsData={prospectsData} userProfileData={userProfileData} isVisible={addNewCampaign} />
        <h3>Campaigns:</h3>
        {!Array.isArray(campaignsData) ? []: campaignsData?.map((c) => {
          return (
             <div key={c._id}><CampaignPin surveysData={surveys} prospectsData={prospectsData} campaign={c} userProfileData={userProfileData} setCampaign={setCampaign}/></div>
          )
        })}     
    </div>
  )
}

export default CreateCampaign

export const CampaignForm = ({initialDoc, surveysData, toggleForm=()=>{}, prospectsData, userProfileData, isVisible=true}) => {
      
      const {user} = useAuthContext(AuthContext)
      const { apiUrl, language, hideTestButtons} = useStateContext()
      
      const [campaignId, setCampaignId] = useState(generateMongoDBId())
      const [richEditorValue, setRichEditorValue] = useState()
      const [loadUsers, setLoadUsers] = useState(false)
      const [richEditorObj, setRichEditorObj] = useState()
      const [buttonLink, setButtonLink] = useState()
      const [buttonText, setButtonText] = useState()
      const [campaignTitle, setCampaignTitle] = useState()
      const [groupId, setGroupId] = useState()
      const [emails, setEmails] = useState([])
      
      const [subject, setSubject] = useState()
      const [pageType, setPageType] = useState()
      const [contactType, setContactType] = useState({label: "Prospects", value: "Prospects"})

      const [contacts, setContacts] = useState([])
      const [testContact, setTestContact] = useState()
      const [sentEmailResponses, setSentEmailResponses] = useState([])
      const isSent = initialDoc?.status === "Sent"
      const sentOn = initialDoc?.updatedAt && format(initialDoc?.updatedAt, "dd/MM/yyyy HH:mm"); 
 
      const screenSizeNotMobile = useMediaQuery("(min-width: 742px)");

      const htmlData = {richEditorObj, campaignId, pageType, buttonLink, buttonText, userProfileData, language}
      const pageTypesOptions = [{label: "landingPage", value: "landingPage"}, {label: "survey", value: "survey"}]

      const surveys = !Array.isArray(surveysData) ? [] : surveysData?.map((survey)=>({label: survey?.title, value: survey?._id}))

      

  useEffect(() => {
    if(initialDoc && !campaignTitle){
      //console.log("found initial doc shdwdfhuwedf", initialDoc)
      setCampaignId(initialDoc?._id)
      setRichEditorObj(initialDoc?.richEditorObj)
      setGroupId(initialDoc?.groupId)
      setButtonText(initialDoc?.buttonText)
      
      setCampaignTitle(initialDoc?.campaignTitle)
      setEmails(initialDoc?.emails?.map((e) => {
        const findEmailInProspectsData = !Array.isArray(prospectsData) ? [] : prospectsData?.find((p) => p.email === e)
        //console.log("dmlasmdalskdmsalkd", {e, findEmailInProspectsData})
        if(findEmailInProspectsData && !findEmailInProspectsData?.unsubscribed){ {
          return e
        }
      }})?.filter((x) => x))

      setSubject(initialDoc?.subject);
      if(initialDoc?.contactType) {
        setContactType({label: initialDoc?.contactType, value: initialDoc?.contactType})
      };
      if(!initialDoc?.pageType){
        setButtonLink(initialDoc?.buttonLink)
      }
      if(initialDoc?.pageType){
        const findSurveyLabel = surveys?.find((s) => s.value === initialDoc?.buttonLink)?.label
        setPageType({label: initialDoc?.pageType, value: initialDoc?.pageType});
        setButtonLink({label: findSurveyLabel? findSurveyLabel : initialDoc?.buttonLink, value: initialDoc?.buttonLink})
      }
    }
    
  },[initialDoc, prospectsData, surveys])

  useEffect(() => {
    if(prospectsData && emails?.length){
      const selectedContacts = !Array.isArray(emails) ? [] : emails?.map((email)=> !Array.isArray(prospectsData) ? undefined : prospectsData?.find((p) => !p.unsubscribed && p.email === email))?.filter((x) => x)      
      setContacts(selectedContacts)

    }
  },[prospectsData, emails])

  const queryClient = useQueryClient()
      const onError = (e) => {
      console.log("Campaign Error:", e)
  }
  const onSuccess = (json) => {
    if(!initialDoc) {
      successAlert("Campaign created successfully");
    }
    if(initialDoc) {
      successAlert("Campaign updated successfully");
    }

    //dispatch({type: 'CREATE_DOCUMENT', payload: json})
  }

   const { mutate: createCampaign } = useMutation({ 
    mutationFn: async(doc) => {
      return await _CREATE({doc, user, route: `${apiUrl}/campaigns`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['campaignsData'] }),
    mutationKey: ['campaignsData'],
  })
    const { mutate: editCampaign } = useMutation({ 
    mutationFn: async(doc) => {
      return await _UPDATE({doc, user, route: `${apiUrl}/campaigns/${campaignId}`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['campaignsData'] }),
    mutationKey: ['campaignsData'],
  })
        const campaignDoc = {
            ...(initialDoc ? initialDoc : {}), groupId, richEditorObj, _id: campaignId, buttonLink: buttonLink?.value ? buttonLink?.value : buttonLink, pageType: pageType?.value, contactType: contactType?.value, buttonText, campaignTitle, emails: emails, subject
        }
      const saveCampaign = () => {

        if(!initialDoc) createCampaign(campaignDoc)
        if(initialDoc)  editCampaign(campaignDoc)
        process.env.NODE_ENV === "development" && console.log("SAVE CAMPAIGN:", campaignDoc) 
    }
    const duplicateCampaign = () => {
      const duplicate = (name) => {
        const newDoc = {...campaignDoc, createdAt: new Date(), _id: generateMongoDBId(), status:"inProgress", campaignTitle: name}
        createCampaign(newDoc)
        console.log("jankjndkjasnx",{newDoc})
        toggleForm(false)
      } 
      addNameSwal({inputValue: campaignTitle, okFn: duplicate})
    }
    const sendCampaign = () => {
      const newDoc = {...campaignDoc, status:"Sent"}
      const emailsToSend = !Array.isArray(emails) ? [] : contacts?.map((contact) => {
        const emailId = generateMongoDBId()
        const html = EmailHtml({data: {...htmlData, firstName: contact?.firstName, contactEmail: contact?.email, emailId}, language})
        const userFirstName = userProfileData?.firstName ? userProfileData?.firstName : ""
        const userLastName = userProfileData?.lastName ? userProfileData?.lastName : ""
        const userFullName = `${userFirstName} ${userLastName} `
        const htmlVersion = (htmlDraft, _id) => {
              return `<html><body style="margin: 0; padding: 0; background-color: #fcba03;">${htmlDraft}<img src='${apiUrl}/email/email-assets/notification-status/${_id}' width='1' height='1' style='display:none' alt='Email notification status' /></body></html>`
          }
        const emailDoc =  {
                _id: emailId,
                campaignId: campaignId,
                subject: subject,
                htmlBody: htmlVersion(html, emailId),
                richEditorObj: richEditorObj,
                text: "",
                toEmail: contact?.email,
                sender: `${userFullName} ${dT({en: "reMind", it: "reMind"}, language)}`,
                replyTo: user?.email, //replyTo
            }
        return emailDoc
        })
      if(!emailsToSend?.length) {
        errorAlert("No emails found")  
        return
      }
      let emailResponses = []
      const postingEmailExpress = async(data, result=()=>{}) => {
    
        process.env.NODE_ENV === "development" && console.log("SENDING EMAIL", JSON.stringify(data))
       
        const response = await fetch(`${apiUrl}/email/send-email`,{
          method:"POST",
          headers: new Headers({'content-type': 'application/json'}), 
          body: JSON.stringify(data),

        })
        const dataResponse = await response.json()
        emailResponses.push(dataResponse)
        process.env.NODE_ENV === "development" && console.log("emailDataResponse",dataResponse)
        result(dataResponse)
        
      }
      const queue = new PromiseQueue({
          concurrency: 1,
          intervalCap: 1,
          interval: 1000,
        })
        Promise.all(!Array?.isArray(emailsToSend) ? [] : emailsToSend?.map((email) => {
              queue.add(async() => {
                if(!email?.toEmail) {
                  const emailErrorResponse = {Error: "Email not found"}
                  process.env.NODE_ENV === "development" && console.log("NO EMAIL FOUND FOR", emailErrorResponse)  
                  emailResponses.push(emailErrorResponse)
                  return
                }
                process.env.NODE_ENV === "development" && console.log(`SPEDISCO A ${email?.toEmail}`)
                return  await postingEmailExpress(email)
              }) 
          }))?.then(() => {
              process.env.NODE_ENV === "development" && console.log("SPEDITO TUTTO")
              setSentEmailResponses(emailResponses)
              editCampaign({...campaignDoc, status:"Sent"})
              console.log("pwdkewpodkeop",{newDoc, emailsToSend})
          })

/*       
        for(const email of emailsToSend) {
            queue.add(() => {
              if(!email?.toEmail) {
                const emailErrorResponse = {Error: "Email not found"}
                process.env.NODE_ENV === "development" && console.log("NO EMAIL FOUND FOR", emailErrorResponse)  
                emailResponses.push(emailErrorResponse)
                return
              }
              process.env.NODE_ENV === "development" && console.log(`SPEDISCO A ${email?.toEmail}`)
              return  postingEmailExpress(email)
            }) 
        } */
/*       queue.onEmpty(() => {
        process.env.NODE_ENV === "development" && console.log("SPEDITO TUTTO")
        setSentEmailResponses(emailResponses)
        editCampaign({...campaignDoc, status:"Sent"})
        console.log("pwdkewpodkeop",{newDoc, emailsToSend})
    }) */

      
    }

    //================================================
    const emailEditor = (data) => { 
        const newValue = {...data, blocks: data?.blocks?.map((x)=>({...x, _key:generateMongoDBId()}))}
        setRichEditorValue(newValue)
    }
 
    const update = (value) => {
        //setLaws([...filteredArray, value])
        setRichEditorObj(value)
        const queryDoc = {
            doc: value,
        }
        process.env.NODE_ENV === "development" && console.log("SAVE:", queryDoc)
    }

   
    const testFunction = () => {
     console.log("JALSKDJLKSADJ", {htmlData, emails, prospectsData, contacts, testContact, initialDoc, sentEmailResponses})
    }
  return (
          <VisDiv rules={[isVisible]} style={{ display: "flex", flexDirection: screenSizeNotMobile ? "row" : "column", padding:"20px"}}>
            {/* =========== EDIT FORM ============= */}
            <VisDiv style={{padding:"20px", flex: 1, display: "flex", flexDirection: "column"}}>
              <VisDiv rules={[!isSent]} >
                  <BlueButton fn={testFunction} hideTestButtons={hideTestButtons}/>
                  <label>Campaign Title:</label>
                  <input 
                      type="text"
                      onChange={(e) => setCampaignTitle(e.target.value)}
                      value={campaignTitle}
                  />
                  <label>Subject:</label>
                  <input 
                      type="text"
                      onChange={(e) => setSubject(e.target.value)}
                      value={subject}
                  />
                
                  <div>
                      <RichTextEditor 
                          fullWidth={true}
                          onBlur={()=>update(richEditorValue)} 
                          noFocus={true} 
                          existingDoc={richEditorObj} 
                          editorDoc={emailEditor}
                          updateInitialData={true}    
                      />
                  </div>
                  <div>
                      <label>Button Text:</label>
                      <input 
                          type="text"
                          onChange={(e) => setButtonText(e.target.value)}
                          value={buttonText}
                      />

                
                      <label>Page Type</label>
                      <FieldDropdown
                        placeHolder = "Select Page Type"
                        options = {pageTypesOptions}
                        initialValue = {pageType}
                        onChange={(e) => {
                          setPageType(e)
                          setButtonLink(undefined)
                        }}
                      />
                      <label>Button Link:</label>
                      <VisDiv rules={[pageType?.value === "landingPage"]}>
                        <FieldDropdown
                          placeHolder = "Select Landing Page"
                          options = {landingPages}
                          initialValue = {buttonLink}
                          onChange={(e) => {
                            setButtonLink(e)
                          }}
                          
                        />
                        <VisDiv rules={[buttonLink, testContact]}>
                          <p>{completeLink({buttonLink, pageType: pageType?.value, campaignId, email: testContact?.email})}</p>
                        </VisDiv>
                        
                      </VisDiv>
                      <VisDiv rules={[pageType?.value === "survey"]}>
                        <FieldDropdown
                          placeHolder = "Select Survey"
                          options = {surveys}
                          initialValue = {buttonLink}
                          onChange={(e) => {
                            setButtonLink(e)
                          }}
                          
                        />
                        <VisDiv rules={[buttonLink, testContact]}>
                          <p>{completeLink({buttonLink, pageType: pageType?.value, campaignId, email: testContact?.email})}</p>
                        </VisDiv>
                      </VisDiv>
                      <VisDiv rules={[!pageType]}>
                        <input 
                            type="text"
                            onChange={(e) => setButtonLink(e.target.value)}
                            value={buttonLink}
                        />
                      </VisDiv>                  
                  </div>
                  <FieldDropdown
                    options = {[{label: "Prospects", value: "Prospects"}, {label: "Users", value: "Users" }]}
                    initialValue = {{label: "Prospects", value: "Prospects"}}
                    onChange={(e) => {
                      setContactType(e)
                    }}
                  />
              </VisDiv>
              <VisDiv rules={[isSent]}>
                <ReportLine visible={true} label={<T obj={{en: "Campaign Title", it: "Titolo Campagna"}}/>} value={campaignTitle} />
                <ReportLine visible={true} label={<T obj={{en: "Subject", it: "Oggetto"}}/>} value={subject} />
                <ReportLine visible={emails?.length} label={<T obj={{en: "Emails Sent", it: "Email Inviate"}}/>} value={`${emails?.length}`} />
                <ReportLine visible={sentOn} label={<T obj={{en: "Sent On", it: "Spedito Il"}}/>} value={sentOn} />
                <ReportLine visible={pageType?.label} label={<T obj={{en: "Page Type", it: "Tipo Pagina"}}/>} value={pageType?.label} />
                <ReportLine visible={true} label={<T obj={{en: "Page", it: "Pagina"}}/>} value={buttonLink?.label || buttonLink} />
                <ReportLine visible={contactType?.label} label={<T obj={{en: "Contact Type", it: "Contatto"}}/>} value={contactType?.label} />
             
                <VisDiv rules={[pageType?.label === "survey"]} style={{display:"flex", justifyContent: "left", alignItems: "center", padding: "10px", borderBottom: "1px solid #ccc", margin: "5px 0"}}>
                  <div>{<T obj={{en: "Survey Report", it: "Survey Report"}}/>}:</div>
                  <TbReportAnalytics
                      style={{cursor: 'pointer', marginLeft: '10px'}} 
                      size={27} 
                      onClick={() =>  window.open(`${window.location.origin}/survey-report?_id=${buttonLink?.value}&&campaignId=${campaignId}&&campaignTitle=${campaignTitle}`, '_blank')}
                  />
                </VisDiv>

              </VisDiv>
              <VisDiv>
                <SelectContactEmails surveyId={(buttonLink?.value && pageType?.label === "survey" ? buttonLink?.value : undefined)} campaignTitle={campaignTitle} campaignId={campaignId} isSent={isSent} setGroupId={setGroupId} groupId={groupId} prospectsData={prospectsData} contactType={contactType} contacts={contacts} emails={emails} setEmails={setEmails}/>
              </VisDiv>
            </VisDiv>

             {/* =========== EDIT FORM END ============= */}
              {/* =========== EDIT FORM END ============= */}
            <div style={{flex: 1, display: "flex", flexDirection: "column"}}> 
                <FieldDropdown
                  options = {contacts?.map((x) => ({...x,label: fullNameOrEmail(x), value: x?._id}))}
                  initialValue = {testContact}
                  onChange={(e) => {
                    setTestContact(e)
                  }}
                  placeHolder = "Select contact to view email"
                />
                <div style={{  marginBottom: "10px"}} dangerouslySetInnerHTML={{ __html: EmailHtml({data: {...htmlData, firstName: testContact?.firstName, contactEmail: testContact?.email }}) }} />
               {/*  <BlueButton fn={()=>sendCampaign(htmlBody)} text='Send' color='green' />  */}
                <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                  <VisDiv rules={[!isSent]}>
                    <BlueButton fn={saveCampaign} text='Save' color='green' /> 
                  </VisDiv>
                  <VisDiv rules={[initialDoc]}>
                    <BlueButton fn={duplicateCampaign} text='Duplicate' color='orange' /> 
                  </VisDiv>
                  <VisDiv rules={[initialDoc, !isSent]}>
                    <BlueButton fn={()=>{
                      if(isSent) {
                              Swal.fire({
                                  title:  "Campaign was already sent",
                                  text: "Are you sure you want to send it again?",
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#d33',
                                  confirmButtonText: "YES, PROCEED",
                                  cancelButtonText: "NO, CANCEL"
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    sendCampaign()
                                  }
                                })
                      } else {
                        sendCampaign()
                      }
                      
                      }} text='Send Campaign'  /> 
                  </VisDiv>
                </div>
            </div>
          </VisDiv>
  )

}

export const completeLink = ({buttonLink, pageType, email, emailId, campaignId}) => {
        const frontendUrl = process.env.NODE_ENV === "development" ? "http://localhost:3000" : process.env.REACT_APP_FRONTEND_URL
        if(!buttonLink){
          return undefined
        }
        if(buttonLink?.value && pageType == "landingPage"){
          return `${frontendUrl}/landing/${buttonLink?.value}?hideHeader=true&hideFooter=true&userEmail=${email}&emailId=${emailId}&campaignId=${campaignId}`
        }
        if(buttonLink?.value && pageType == "survey"){
          return `${frontendUrl}/survey/?_id=${buttonLink?.value}&userEmail=${email}&emailId=${emailId}&campaignId=${campaignId}`
        }
        if(!buttonLink?.value && !pageType && buttonLink){
          return buttonLink
        }
        
      }
export const EmailHtml = ({data ={}}) => {
    const {firstName, richEditorObj, pageType, buttonLink, buttonText, userProfileData, language, contactEmail, emailId, campaignId} = data
        
        const profilePictureLine = userProfileData?.profilePictureUrl ? `
            <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 30px;">
              <div style="flex: 1; height: 1px; margin-right: 15px; background-color: #ccc;"></div>
              <img src="${userProfileData?.profilePictureUrl}" alt="Logo" style="width: 80px; border-radius: 50%; height: 80px;">
              <div style="flex: 1; height: 1px; margin-left: 15px; background-color: #ccc;"></div>
            </div> 
        `:""
        const userFirstName = userProfileData?.firstName ? userProfileData?.firstName : ""
        const userLastName = userProfileData?.lastName ? userProfileData?.lastName : ""
        const userProfessionalTitle = userProfileData?.professionalTitle ? userProfileData?.professionalTitle : ""
        const userFullName = `${userFirstName} ${userLastName} `
        const frontendUrl = process.env.NODE_ENV === "development" ? "http://localhost:3000" : process.env.REACT_APP_FRONTEND_URL
        const emailBodyHtml = draftToHtml(richEditorObj)
        const firstLine = firstName ? `${dT({en:'Dear', it:'Gentile'}, language)} ${firstName},` : `${dT({en:'Greetings, ', it:'Ciao,'}, language)}`
        const reMind = `<span style="color: #fcba03;"><b>reMind</b></span>`
        const unsubscribeLink = `${frontendUrl}/uerfheuryfhh/unsubscribe?hideHeader=true&hideFooter=true&userEmail=${contactEmail}&emailId=${emailId}&campaignId=${campaignId}`
        const button = (buttonLink && buttonText) ? `                             
        <a href=${completeLink({buttonLink, pageType: pageType?.value, email: contactEmail, emailId, campaignId})}
                style="
                display: inline-block;
                background-color: #fcba03;
                color: white;
                text-decoration: none;
                padding: 12px 24px;
                border-radius: 10px;
                margin-top: 15px;
                margin-bottom: 15px;
                font-weight: bold;
                cursor: pointer;
                font-family: sans-serif;
                ">
                ${buttonText}
            </a>
            `:"" 
        const footer = `
              <div  
                text-align: center; 
                padding: 30px; 
                width: 100%; 
                box-sizing: border-box; 
                display: flex; 
                justify-content: center; 
                align-items: center; 
                flex-direction: column;"
              >
                <img src="https://www.remind.is/reMindLogo.png" alt="reMind Logo" style="height:80px"} />
                <p style="width:600px; overflow: hidden; color: #343C5F; font-family: Arial, sans-serif;">
                  ${ dT({
                      en: ` 
                        reMind is intended to be used as a complementary tool, under the supervision of qualified professionals. 
                        It is not a medical device, and it does not offer healing, treatment, or cures for any health condition.  
                        Always consult with a healthcare professional for medical advice. if you don't want to receive emails like this,
                        you can unsubscribe <a href=${unsubscribeLink}>here</a>.
                        `,
                      it: 
                        `reMind è stato realizzato come strumento complementare, sotto la supervisione di professionisti qualificati.  
                        Non è un dispositivo medico e non offre guarigione, trattamento o cure per alcuna condizione di salute.
                        Consultare sempre un professionista sanitario per consigli medici. Se non desideri ricevere email come questa, 
                        puoi disiscriverti <a href=${unsubscribeLink}>qui</a>.`,
                    }, language)}
                  </p>
            
              </div>
        `
        
        const htmlBody = `
                <table width="100%" bgcolor="#fcba03" cellpadding="0" cellspacing="0" border="0">
                    <tr>
                      <td align="center" style="padding: 40px 0;">
                        <table width="600" cellpadding="0" cellspacing="0" border="0"
                              style="background-color: #ffffff; margin: 14px; border-radius: 10px; overflow: hidden; color: #343C5F; font-family: Arial, sans-serif;">
                          <tr>
                            <td style="padding: 20px;">
                              ${profilePictureLine}
                              <p style="margin: 0 0 15px 0;">${firstLine}</p>
                              ${emailBodyHtml ? emailBodyHtml : ""}  
                              
                              <p style="margin: 0 0 15px 0; text-align: center;">
                                ${button}
                              </p>
                              <p style="margin: 0 0 15px 0;>
                                ${dT({
                                  en: `I believe it will be a powerful complement to our sessions, and I look forward to seeing you there.`,
                                  it: `Credo che sarà un valido complemento al lavoro che stiamo facendo insieme, e non vedo l’ora di ritrovarla lì.`
                                }, language)}
                              </p>
                              <p style="margin: 0 0 15px 0;">
                                ${dT({
                                  en: `Warm wishes,`,
                                  it: `Un caro saluto,`
                                }, language)}
                              </p>
                              <h1 style="margin: 30px 0 0 0; font-size: 24px;">${userFullName}</h1>
                              <h4> ${userProfessionalTitle} </h4>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="padding:0 0 30px 0; width:600px">
                        ${footer}
                      </td>
                    </tr>
                  </table>
              `
  return htmlBody
}
export const CampaignPin = ({campaign, prospectsData, userProfileData, surveysData }) => {

  const [viewEdit, setViewEdit] = useState(false)
  const tagColor = () => {
    if(campaign?.status === "inProgress") {
      return "orange"
    }
    if(campaign?.status === "completed") {
      return "green"
    }
    if(campaign?.status === "failed") {
      return "red"
    }
  }
  return (
    <div style={{ border: "1px solid #ccc", margin: "10px", padding: "10px", borderRadius: "10px"}}>
      <div style={{display: "flex", alignItems: "center", justifyContent: "left", flexDirection: "row"}}>
          <div style={{marginRight: "10px"}}>
            <Tag color={tagColor()} text={campaign?.status}/>
          </div>
          <FiEdit 
            style={{cursor: 'pointer', marginRight: '10px'}} 
            size={20} 
            onClick={() => setViewEdit(!viewEdit)}
          />

        <h3>{campaign?.campaignTitle}</h3>
      </div>
      <CampaignForm surveysData={surveysData} toggleForm={setViewEdit} prospectsData={prospectsData} userProfileData={userProfileData} initialDoc={campaign} isVisible={viewEdit} />
    </div>
  )
}

export const SelectContactEmails = ({emails, surveyId, isSent, contacts, prospectsData, setGroupId, groupId, campaignId, campaignTitle, setEmails, contactType }) => {

      const {user} = useAuthContext(AuthContext)
      const {hideTestButtons, apiUrl, language} = useStateContext()
      const queryClient = useQueryClient()
      const [group, setGroup] = useState()
      const [loadReportData, setLoadReportData] = useState(false)
      const [seenFilter, setSeenFilter] = useState(false)
      const [clickedFilter, setClickedFilter] = useState(false)
      const [surveyResponseFilter, setSurveyResponseFilter] = useState(false)

        const { data: campaignMarketingLogData, isLoading: campaignMarketingLogDataLoading} = useQuery({
          queryKey: ['campaignMarketingLogData'],
          enabled: !!loadReportData,
          queryFn: async () => await _FETCH({route: `${apiUrl}/marketing-logs/byCampaignId/${campaignId}`, user})
        });
       // console.log("kjankjsnd MARKETING LOGS", {campaignMarketingLogData})
        const { data: campaignEmailsData, isLoading: campaignEmailsDataLoading} = useQuery({
          queryKey: ['campaignEmailsData'],
          enabled: !!loadReportData,
          queryFn: async () => await _FETCH({route: `${apiUrl}/email/byCampaignId/${campaignId}`, user})
        });

      const { data: contactGroupsData, isLoading: contactGroupsLoading} = useQuery({
          queryKey: ['contactGroupsData'],
          enabled: !!user,
          queryFn: async () => await _FETCH({route: `${apiUrl}/contact-groups`, user})
        });

          const { data: surveyResponses,  isLoading: isLoadingSurveyResponses } = useQuery({
              queryKey: ['surveyResponses', surveyId],
              enabled: !!surveyId && !!loadReportData,
              queryFn: async () => {
                  const response = await fetch(`${apiUrl}/survey-responses/by-survey/${surveyId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch survey');
                  }
                 
                  return response.json();
              }
          });

      useEffect(() => {
        if (!group && groupId && contactGroupsData?.length > 0 ) {
          const findCroup =  contactGroupsData?.find((group) => group._id === groupId)
          if(findCroup) {
            setGroup({...findCroup, label: findCroup?.title, value: findCroup?._id})
          }
          
        }
      if (group && !groupId) {
          setGroupId(group?._id)
        }
      },[contactGroupsData, group])
      const onSuccess = () => {
        if (group) {
          successAlert("Contact group updated successfully")
        } else {
        successAlert("Contact group created successfully")
        }
      }
      const onError = (e) => {
        errorAlert("Error creating/updating contact group")
        console.log("Error creating/updating contact group", e)
      }
      const { mutate: createContactGroup } = useMutation({  
          mutationFn: async(doc) => {
            return await _CREATE({doc, user, route: `${apiUrl}/contact-groups`, onError, onSuccess})
          },
          onSettled: () => queryClient.invalidateQueries({ queryKey: ['contactGroupsData'] }),
          mutationKey: ['contactGroupsData'],
        })
      const { mutate: updateContactGroup } = useMutation({ 
          mutationFn: async(doc) => {
            return await _UPDATE({doc, user, route: `${apiUrl}/contact-groups/${group?._id}`, onError, onSuccess})
          },
          onSettled: () => queryClient.invalidateQueries({ queryKey: ['contactGroupsData'] }),
          mutationKey: ['contactGroupsData'],
        })

        const testFunction = () => {
          process.env.NODE_ENV === "development" && console.log("testFunction eoifkjoierf",
            { emails, campaignEmailsData, campaignMarketingLogData, surveyResponses, group, groupId, prospectsData, contactType, surveyId, contactGroupsData }
          )
      }
      
      const createGroup = () => {
          const createFn = (name) => {
            const doc = {
              title: name,
              emails: emails,
            }
            createContactGroup(doc)
          }
          addNameSwal({ okFn: createFn})
      }
      const updateGroup = () => {
            const updateFn = (name) => {
            const doc = {
              ...group,
              title: name,
              emails: emails,
            }
            updateContactGroup(doc)
            setGroup({...doc, label: doc?.title, value: doc?._id})
          }
          addNameSwal({inputValue: group?.title, title:"Here you can change the group title", okFn: updateFn})
      }

      const expandedContacts = !Array?.isArray(contacts) ? [] : contacts?.map((p) => {
        const marketingLogs = !Array?.isArray(campaignMarketingLogData) ? [] : campaignMarketingLogData?.filter((l) => l?.prospectEmail === p?.email || l?.user_id === p?._id)
        const sentEmail = !Array?.isArray(campaignEmailsData) ? undefined : campaignEmailsData?.find((l) => l?.toEmail === p?.email)
        const surveyResponse = !Array?.isArray(surveyResponses) ? undefined : surveyResponses?.find((x)=> x?.email === p?.email)
        const expandedContact = {...p, marketingLogs, sentEmail, surveyResponse}
        return expandedContact
      })
        ?.filter(x=>!seenFilter ? x : x?.sentEmail?.seenAt)
        ?.filter(x=>!clickedFilter ? x : x?.marketingLogs?.length > 0)
        ?.filter(x=>!surveyResponseFilter ? x : x?.surveyResponse)
        const createFilteredGroup = () => {
          const createFn = (name) => {
            const filteredEmails = !Array?.isArray(expandedContacts) ? undefined : expandedContacts?.map((x) => x?.email)
            const doc = {
              title: name,
              emails: filteredEmails,
              campaignId: campaignId,
              campaignTitle: campaignTitle
            }
            if(!filteredEmails){
              errorAlert("No filtered emails found")
              return
            }
            createContactGroup(doc)
          }
          const addToTitle = [
            {isTrue: seenFilter, label: dT({en: "Seen", it: "Visto"}, language)}, 
            {isTrue: clickedFilter, label: dT({en: "Clicked", it: "Clicked"}, language)}, 
            {isTrue: surveyResponseFilter, label: dT({en: "Survey Response", it: "Risposta Sondaggio"}, language)}]
            .map((str) => str?.isTrue ? str?.label : undefined).filter((str) => str).join(" | ")
          addNameSwal({inputValue: `${campaignTitle} |  ${addToTitle}`, title:"Adding this filterted group", okFn: createFn})
      }
  if(loadReportData && (campaignMarketingLogDataLoading || campaignEmailsDataLoading) ) return <Loading/>
  if(loadReportData && surveyId && isLoadingSurveyResponses ) return <Loading/>
  return (
  <div>
    
    <div style={{padding:"20px", textAlign:"center"}}><h2>{"CONTACTS"}</h2></div>
    <BlueButton fn={testFunction} hideTestButtons={hideTestButtons} text="Test Contact Emails" />
    <VisDiv rules={[isSent]}>
      <BlueButton fn={()=>setLoadReportData(true)} text="Load Report Data" />
      <VisDiv>
        <VisDiv ruleType={"OR"} rules={[seenFilter, clickedFilter, surveyResponseFilter]}>
          <BlueButton fn={createFilteredGroup} text="Create New Filtered Group" />
        </VisDiv>
      </VisDiv>
      <ReportLine visible={group?.title} label={<T obj={{en: "Group", it: "Grupppo"}}/>} value={group?.title}/>
      <VisDiv rules={[loadReportData]}>
        <h4 style={{marginTop:"20px", marginBottom:"10px"}}>{"Filters"}</h4>
        <div style={{display:"flex", cursor: "pointer"}}>
          <Tag onClick={()=>{setSeenFilter(!seenFilter)}} text={<T obj={{en: "Seen", it: "Visto"}}/>} color={seenFilter ? blueColour : "grey"} style={{marginRight:"10px"}}/>
          <Tag onClick={()=>setClickedFilter(!clickedFilter)} text={<T obj={{en: "Clicked", it: "Clicked"}}/>} color={clickedFilter ? blueColour : "grey"} style={{marginRight:"10px"}}/>
          <VisDiv rules={[surveyId]}>
            <Tag onClick={()=>setSurveyResponseFilter(!surveyResponseFilter)} text={<T obj={{en: "Survey Response", it: "Risposta Sondaggio"}}/>} color={surveyResponseFilter ? blueColour : "grey"} style={{marginRight:"10px"}}/>
          </VisDiv>
        </div>
        <Divider height={"25px"} bottom={"15px"}/>
          {
            !Array?.isArray(expandedContacts) ? [] : expandedContacts
            ?.map((p) => {
            return <ContactPinReport  key={p._id} data={{campaignTitle, campaignId, contact: p}}/>
            }) 
          }
        </VisDiv>
    </VisDiv>
    <VisDiv rules={[!isSent]}>
      <BlueButton fn={createGroup} text="Create Group" />
      <VisDiv rules={[group]}>
        <BlueButton fn={updateGroup} text="Update Group" />
      </VisDiv>
      <FieldDropdown
          options={!Array?.isArray(contactGroupsData) ? [] : contactGroupsData?.map((x) => ({...x, label: x?.title, value: x?._id}))}
          onChange={(e)=>{
            setGroup(e)
            setGroupId(e?._id)
            //prospectsData
            setEmails(e?.emails?.map((e) => {
              const findEmailInProspectsData = !Array.isArray(prospectsData) ? [] : prospectsData?.find((p) => p.email === e)
              //console.log("dmlasmdalskdmsalkd", {e, findEmailInProspectsData})
              if(findEmailInProspectsData && !findEmailInProspectsData?.unsubscribed){ {
                return e
              }
            }})?.filter((x) => x))
              }}
          initialValue={group}
          placeHolder="Select a contact group"
          isSearchable={true}
        />
          {
            !Array?.isArray(prospectsData) ? [] : prospectsData?.map((p) => {
            return <ContactPin  key={p._id} data={{contact:p, emails, setEmails}}/>
            }) 
          }
       </VisDiv>
  </div>
  )

}

export const ContactPin = ({children, data={}}) => {

    const { contact, emails, setEmails,} = data

    const emailFn = () => {
        const isEmailInEmails = emails?.some((x)=>x === contact?.email)
        if(isEmailInEmails) {
            setEmails(emails?.filter((x)=>x !== contact?.email))
        } else {
            if(emails?.length < 10) {
            setEmails([...emails, contact?.email])
        }
        }
      
    }

    const testFunction = (e) => {
      e?.stopPropagation()
        process.env.NODE_ENV === "development" && console.log("wkemelkwmxc", {emails, contact})
    }
     const contactFullName = fullNameOrEmail(contact)
    return (
        <div className="radio-button-container" style={{alignItems: "center"}}>
            <VisDiv onClick={emailFn} >
                <VisDiv className="flex-center" rules={[!emails?.some((x)=>x === contact?.email)]}>
                    <CiCircleCheck size={24} />
                </VisDiv>  
                <VisDiv className="flex-center"rules={[emails?.some((x)=>x === contact?.email)]}>
                    <HiCheckCircle size={24} />
                </VisDiv>  
            </VisDiv>
            
            <div className="margin-left flex-center">
                <p>{contactFullName}</p>
            </div>
            <div className="margin-left flex-center">
                <BlueButton hide={true} margins={false} fn = {testFunction}/>
            </div>
          
        </div>
    );
} 

export const ContactPinReport = ({children, data={}}) => {

    const { contact, campaignTitle, campaignId } = data
    const marketingLogs = contact?.marketingLogs
    const sentEmail = contact?.sentEmail
    const surveyResponse = contact?.surveyResponse

    const seenAt = sentEmail?.seenAt && format(sentEmail?.seenAt, "dd/MM/yyyy HH:mm"); 
    const emailLinkMArketingLog = !Array?.isArray(marketingLogs) ? [] : marketingLogs?.filter((l) => l?.logType === "emailLink")
    const nLogs = emailLinkMArketingLog?.length


    const testFunction = (e) => {
      e?.stopPropagation()
        process.env.NODE_ENV === "development" && console.log("wkemelkwmxc", {contact, marketingLogs, sentEmail })
    }
     const contactFullName = fullNameOrEmail(contact)
    return (
        <div className="radio-button-container" style={{alignItems: "center"}}>            
            <div className="margin-left flex-center">
                <p>{contactFullName}</p>
            </div>
            <VisDiv style={{marginLeft:"5px"}} rules={[seenAt]}>
              <Tag color={goldColour} text ={`Seen: ${seenAt}`}/>
            </VisDiv>
            <VisDiv style={{marginLeft:"5px"}} rules={[nLogs > 0]}>
              <Tag color={lighterBlueColour} text ={`Clicked ${nLogs} times`}/>
            </VisDiv>
            <VisDiv style={{marginLeft:"5px"}} rules={[surveyResponse]}>
                <TbReportAnalytics
                  style={{cursor:"pointer"}}
                  size={27} 
                  onClick={() => window.open(`${window.location.origin}/survey-report?_id=${surveyResponse?.surveyId}&&email=${contact?.email}&&campaignId=${campaignId}&&campaignTitle=${campaignTitle}`, '_blank')}
               />
            </VisDiv>
            <div className="margin-left flex-center">
                <BlueButton hide={true} margins={false} fn = {testFunction}/>
            </div>
          
        </div>
    );
}